import { init as initApm } from '@elastic/apm-rum';

const apm = initApm({
    serviceName: process.env.VUE_APP_ELASTIC_APM_NAME || 'carpooling',
    serverUrl: process.env.VUE_APP_ELASTIC_APM_SERVER_URL || 'http://localhost:8200',
    environment: process.env.VUE_APP_ELASTIC_APM_ENVIRONMENT || 'production',
    serviceVersion: process.env.VUE_APP_ELASTIC_APM_VERSION || '1.0.0',
    active: process.env.VUE_APP_ELASTIC_APM_ACTIVE === 'true',
    distributedTracingOrigins: [
        'https://hawk-gps.street-directory.com.au',
        'https://local-government.street-directory.com.au',
        'https://hawk-def-dev.street-directory.com.au',
        'https://hawk-gov-dev.street-directory.com.au'
    ],
    captureEvents: true,
    capturePerformance: true,
    captureNetwork: true,
    captureSpanStackTraces: true,
    captureExceptions: true,
    captureTransactions: true,
    captureUserInteraction: true,
    captureLongTasks: true,
    captureResourceTimings: true,
    capturePageTransitions: true,
    capturePageViews: true,
    capturePageLoad: true,
    capturePageErrors: true,
    captureExceptions: true,
    captureConsole: true,
    logLevel: process.env.VUE_APP_ELASTIC_APM_LOG_LEVEL || 'info',
    transactionSampleRate: parseFloat(process.env.VUE_APP_ELASTIC_APM_TRANSACTION_SAMPLE_RATE) || 0.1,
    beforeSend: (span) => {
        if (span.name.includes('unwanted')) {
            return null;
        }
        return span;
    }
});

export default apm;
